module.exports = __webpack_public_path__ + "static/media/settings.1a113e7b.png";